<template>
  <component
    :is="component"
    v-bind="props"
    class="card"
    :class="[
      variant,
      theme,
      'stroke-' + stroke,
      `elevate-${elevate}`,
      size,
      `gap-${gap}`,
    ]"
  >
    <slot name="header" />
    <slot />
    <slot name="footer" />
  </component>
</template>
<script lang="ts" setup>
import type { NuxtLinkProps } from '#app';
interface CardProps extends NuxtLinkProps {
  theme?: string;
  stroke?: string;
  variant?: 'tonal' | 'outlined';
  is?: string;
  to?: string;
  href?: string;
  elevate?: 'none' | 'all' | 'desktop' | 'mobile';
  size?: 'small' | 'normal' | 'medium';
  padding?: string;
  gap?: 's' | 'n' | 'm' | 'l' | 'xl';
}
const props = defineProps({
  theme: { default: 'primary' },
  stroke: { default: '0' },
  variant: { default: 'outlined' },
  is: { default: 'div' },
  to: null,
  href: null,
  elevate: { default: 'none' },
  size: { default: 'normal' },
  padding: { default: '1.8rem' },
  gap: { default: 'm' }
});
const component = computed(() => {
  if (props.to || props.href) {
    return resolveComponent('NuxtLink');
  } else {
    return props.is;
  }
});
const csspadding = computed(() => props.padding);
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  padding: v-bind(csspadding);
  gap: var(--gap_m);
  @include font('n', 500);
  &.medium {
    @include font('m', 500);
  }
  &.small {
    @include font('s', 500);
  }

  color: var(--color_neutral_500);

  &.elevate-all {
    box-shadow: rgb(0 0 0 / 10%) 0 1px 3px 0, rgb(0 0 0 / 6%) 0 1px 2px 0;
  }
  &.elevate-desktop {
    @include desktop {
      box-shadow: rgb(0 0 0 / 10%) 0 1px 3px 0, rgb(0 0 0 / 6%) 0 1px 2px 0;
    }
  }
  &.gap-s {
    gap: var(--gap_s);
  }
  &.gap-n {
    gap: var(--gap_n);
  }
  &.gap-l {
    gap: var(--gap_l);
  }
  &.gap-xl {
    gap: var(--gap_xl);
  }
}
</style>
